import React from 'react';
export class GivingPages extends React.PureComponent {
	constructor(props, context) {
		super(props, context);
	}

	render() {
		return (
				<section className="giving-pages">
					<h2>Your giving pages</h2>
					<a className="button-secondary" href={secureBaseURL + "common/donation-info.html?tab=GIVING_PAGES"}>See your giving pages</a>
				</section>
		);
	}
}

GivingPages.propTypes = {
};
